import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const UserAvatarPlaceholder = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} data-test="user-avatar-placeholder" {...props}>
    <path
      d="M13 64C13 77.5791 18.3943 90.6021 27.9961 100.204C37.598 109.806 50.6209 115.2 64.2 115.2C77.7791 115.2 90.802 109.806 100.404 100.204C110.006 90.6021 115.4 77.5791 115.4 64C115.4 50.421 110.006 37.398 100.404 27.7962C90.802 18.1943 77.7791 12.8 64.2 12.8C50.6209 12.8 37.598 18.1943 27.9961 27.7962C18.3943 37.398 13 50.421 13 64V64Z"
      fill={colors.grey5}
    />
    <path
      d="M38 94.5C38 95.4283 40.792 96.3185 45.7617 96.9749C50.7314 97.6312 57.4718 98 64.5 98C71.5282 98 78.2686 97.6312 83.2383 96.9749C88.208 96.3185 91 95.4283 91 94.5C91 93.5717 88.208 92.6815 83.2383 92.0251C78.2686 91.3688 71.5282 91 64.5 91C57.4718 91 50.7314 91.3688 45.7617 92.0251C40.792 92.6815 38 93.5717 38 94.5V94.5Z"
      fill={colors.grey15}
    />
    <path
      d="M87.12 86.3588C87.12 80.3755 84.7431 74.6373 80.5123 70.4065C76.2815 66.1757 70.5433 63.7988 64.56 63.7988C58.5767 63.7988 52.8385 66.1757 48.6077 70.4065C44.3769 74.6373 42 80.3755 42 86.3588V93.3604H87.12V86.3588Z"
      fill={colors.purple10}
    />
    <path
      d="M49 45.904C49 49.8249 50.5576 53.5853 53.3301 56.3578C56.1027 59.1304 59.863 60.688 63.784 60.688C67.705 60.688 71.4653 59.1304 74.2379 56.3578C77.0104 53.5853 78.568 49.8249 78.568 45.904V41.2384C78.5317 37.3421 76.9585 33.6177 74.1905 30.8753C71.4225 28.133 67.6837 26.5945 63.7872 26.5945C59.8907 26.5945 56.1519 28.133 53.3839 30.8753C50.6159 33.6177 49.0427 37.3421 49.0064 41.2384L49 45.904Z"
      fill={colors.purple10}
    />
    <path
      d="M49 45.904C49 49.8249 50.5576 53.5853 53.3301 56.3578C56.1027 59.1304 59.863 60.688 63.784 60.688C67.705 60.688 71.4653 59.1304 74.2379 56.3578C77.0104 53.5853 78.568 49.8249 78.568 45.904V41.2384C78.5317 37.3421 76.9585 33.6177 74.1905 30.8753C71.4225 28.133 67.6837 26.5945 63.7872 26.5945C59.8907 26.5945 56.1519 28.133 53.3839 30.8753C50.6159 33.6177 49.0427 37.3421 49.0064 41.2384L49 45.904Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M87.12 86.3588C87.12 80.3755 84.7431 74.6373 80.5123 70.4065C76.2815 66.1757 70.5433 63.7988 64.56 63.7988C58.5767 63.7988 52.8385 66.1757 48.6077 70.4065C44.3769 74.6373 42 80.3755 42 86.3588V93.3604H87.12V86.3588Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
